import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/dashboard";
import Login from "./pages/login";
import SignUp from "./pages/signup";
import ForgotPassword from "./pages/forgotPassword";
import PassCode from "./pages/passCode";
import ChangePassword from "./pages/changePassword";
import Details from "./pages/dashboard/details";
import Main from "./pages/dashboard/main";
import Profile from "./pages/profile";
import { Amplify } from "aws-amplify";
import { ToastContainer } from "react-toastify";
import CaseDetails from "./pages/dashboard/CaseDetails";
import DocumentOverview from "./pages/dashboard/DocumentOverview";
import { AMPLIFY_CONFIG } from "./utilities/config";

Amplify.configure(AMPLIFY_CONFIG);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    ></ToastContainer>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/signup" element={<SignUp />}></Route>
        <Route path="/forgot-password" element={<ForgotPassword />}></Route>
        <Route path="/pass-code" element={<PassCode />}></Route>
        <Route path="/change-password" element={<ChangePassword />}></Route>

        <Route path="/" element={<App />}>
          <Route path="/" element={<Dashboard />}>
            <Route path="/" element={<Main />}></Route>
            <Route path="/dashboard/detail" element={<Details />}></Route>
            <Route path='/case/detail/:id' element={<CaseDetails />} />
            <Route path='/case/detail/:caseId/document/:docId' element={<DocumentOverview />} />
          </Route>
          <Route path="/profile" element={<Profile />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
